const CryptoJS = require("crypto-js"); //引用AES源码js

/**
 * 加密方法
 * @return {string}
 */
export function Encrypt(message, key) {
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  let encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

/**
 * 解密方法
 * @return {string}
 */
export function Decrypt(ciphertext, key) {
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  // direct decrypt ciphertext
  let decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}
